import { createFeatureSelector, createSelector } from '@ngrx/store';
import { mainState } from "src/app/state/app.reducer";
import * as AppState from 'src/app/state/app.state';
import { dashboardState } from './dashboards.reducer';

export interface State extends AppState.AppState {
    dashboard: dashboardState;
}

const getBaseDashboardState = createFeatureSelector<dashboardState>('dashboard');

export const getDashboardsState = createSelector(
    getBaseDashboardState,
    state => state.dashboards
);

export const getDashboardsConfigState = createSelector(
    getBaseDashboardState,
    state => state.dashboardConfig
);

export const getIsDirtyState = createSelector(
    getBaseDashboardState,
    state => state.isDirty
);

export const getselectedDashboard = createSelector(
    getBaseDashboardState,
    state => state.currentDashboardId
);

export const getActiveTabWidgets = createSelector(
    getBaseDashboardState,
    state => state.currentDashboardId ? state.dashboards.find(d => d.id === state.currentDashboardId)?.tabs[0]?.gridItems : null
);
export const getActiveDashboard = createSelector(
    getBaseDashboardState,
    state => state.currentDashboardId ? state.dashboards.find(d => d.visible && d.id === state.currentDashboardId) : null
);

export const getWidgetById = (props: { id: number }) => createSelector(
  getBaseDashboardState,
  state => state.dashboards.flatMap(d => d.tabs).flatMap(t => t.gridItems).find(g => g.id == props.id)
);

const getUserFeatureState = createFeatureSelector<mainState>('mainState');

export const getUserInfoState = createSelector(
  getUserFeatureState,
  state => state.userInfo
);
